import { LoadingOutlined, ArrowUpOutlined,  ArrowDownOutlined, ArrowLeftOutlined ,ArrowRightOutlined} from '@ant-design/icons';
import './index.less';
interface IProps {
  onUp: () => void;
  onDown: () => void;
  onLeft: () => void;
  onRight: () => void;
  loading?: boolean;
  size?: number;
  position?: {
    top?: number | string;
    bottom?: number | string;
    left?: number | string;
    right?: number | string;
  };
}

export function CircleSectorButtons(props: IProps) {
  const { 
    onUp, 
    onDown, 
    onLeft, 
    onRight, 
    loading = false, 
    size = 60,
    position = { top: '20px', left: '20px' }
  } = props;

  // 计算按钮位置和大小
  const center = size / 2;
  const buttonSize = size * 0.3;
  const buttonOffset = size * 0.35;

  return (
    <div 
      className="circle-control-container" 
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: 'absolute',
        ...position
      }}
    >
      {/* 上按钮 */}
      <button
        className="control-button up-button"
        onClick={onUp}
        disabled={loading}
        style={{
          width: `${buttonSize}px`,
          height: `${buttonSize}px`,
          top: `${center - buttonOffset - buttonSize/2}px`,
          left: `${center - buttonSize/2}px`
        }}
      >
        {loading ? <LoadingOutlined /> : <ArrowUpOutlined />}
      </button>

      {/* 下按钮 */}
      <button
        className="control-button down-button"
        onClick={onDown}
        disabled={loading}
        style={{
          width: `${buttonSize}px`,
          height: `${buttonSize}px`,
          top: `${center + buttonOffset - buttonSize/2}px`,
          left: `${center - buttonSize/2}px`
        }}
      >
        {loading ? <LoadingOutlined /> : <ArrowDownOutlined />}
      </button>

      {/* 左按钮 */}
      <button
        className="control-button left-button"
        onClick={onLeft}
        disabled={loading}
        style={{
          width: `${buttonSize}px`,
          height: `${buttonSize}px`,
          top: `${center - buttonSize/2}px`,
          left: `${center - buttonOffset - buttonSize/2}px`
        }}
      >
        {loading ? <LoadingOutlined /> : <ArrowLeftOutlined />}
      </button>

      {/* 右按钮 */}
      <button
        className="control-button right-button"
        onClick={onRight}
        disabled={loading}
        style={{
          width: `${buttonSize}px`,
          height: `${buttonSize}px`,
          top: `${center - buttonSize/2}px`,
          left: `${center + buttonOffset - buttonSize/2}px`
        }}
      >
        {loading ? <LoadingOutlined /> : <ArrowRightOutlined />}
      </button>

      {/* 中心圆 */}
      <div 
        className="center-circle" 
        style={{
          width: `${size * 0.3}px`,
          height: `${size * 0.3}px`,
          top: `${center - size * 0.15}px`,
          left: `${center - size * 0.15}px`
        }}
      />
    </div>
  );
}